import * as THREE from 'three';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { Fikogram } from './Fikogram';
import { FikoEksen } from '../FikoEksen';
import { FikoApt } from './FikoApt';
import { FikoCizimler } from './FikoCizimler';
import { Fikogramlar } from './Fikogramlar';
import { FikoKonum } from '../FikoKonumlar/FikoKonumlar';
import { FikoKutuk } from '../FikoKutuk';
import { FikoperasyonComponent } from '../fikoperasyon/fikoperasyon.component';

declare var $: any;

export class FikoOperasyon extends FikoGrup {
    [key:string]:any;
    override type: any = "Fikoperasyon";
    loader: THREE.FileLoader = new THREE.FileLoader();
    /** */
    konum: FikoKonum;
    /** Operasyona atanmis kutuk (uuid ile saklanir) */
    seciliKutukUuid: string | null = null;

    get seciliKutuk(): FikoKutuk | null {
        if (!this.seciliKutukUuid || !this.sahne) return null;
        let bulunan: FikoKutuk | null = null;
        this.traverse((child: any) => {
            if (!bulunan && child.uuid === this.seciliKutukUuid && child.type === 'FikoKutuk') {
                bulunan = child as FikoKutuk;
            }
        });
        return bulunan;
    }

    kutukSec(kutuk: FikoKutuk | null) {
        this.seciliKutukUuid = kutuk?.uuid ?? null;
        this.sahne?.anaGosterim?.FikoYT?.degisti?.emit();
    }

    kutukleriBul(): FikoKutuk[] {
        const sonuc: FikoKutuk[] = [];
        this.traverse((child: any) => {
            if (child.type === 'FikoKutuk') {
                sonuc.push(child as FikoKutuk);
            }
        });
        return sonuc;
    }
    /** */
    get cizimler(): FikoCizimler {
        return this.children[1] as FikoCizimler;
    };
    set cizimler(val: FikoCizimler) {
        // if (this.children.length > 1) {
        this.children[1] = val;
        // } else {
        //     this.ekle(val);
        // }
    };
    /** */
    get programlar(): Fikogramlar {
        return this.children[2] as Fikogramlar;
    };
    set programlar(val: Fikogramlar) {
        // if (this.children.length > 2) {
        this.children[2] = val;
        // } else {
        //     this.ekle(val);
        // }
    };
    /** */
    sayac = 1;

    sagButonlar: any[] = [
        // {
        //     isim: "Operasyon Ekle",
        //     simge: "plus",
        //     tiklandi: () => {
        //         this.ekleFikogram();
        //     }
        // },
        // {
        //     isim: "Dosyadan Ekle",
        //     simge: "upload",
        //     tiklandi: () => {
        //         this.ekleDosyadan();
        //     }
        // },
    ]

    sagMenu: any[] = [
        {
            baslik: "Düzenle",
            simge: "edit",
            tiklandi: () => {
                this.sahne.anaGosterim.DialogFiko.ac({ bilesen: FikoperasyonComponent, parametreler: { fikoperasyon: this }, $event: null, ayarlar: { baslik: 'Fikoperasyon Nitelikleri', simgeResim: './simgeler/proje.webp' } });
            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                let _this = this;
                $('body')
                    .toast({
                        message: `Fikoperasyon Ve Tüm Alt Aktiviteleri Silinecektir, Onaylıyormusunuz?`,
                        displayTime: 3000,
                        class: 'black',
                        classActions: 'top attached',
                        actions: [{
                            text: 'Evet Onaylıyorum',
                            class: 'red',
                            click: function () {
                                while (_this.children.length) {
                                    _this.remove(_this.children[0]);
                                }

                                _this.parent.remove(_this);
                                _this.sahne.anaGosterim.aktifItem = null;
                                _this.sahne.anaGosterim.FikoYT.degisti.emit();
                                _this.sahne.anaGosterim.ciz();
                            }
                        }, {
                            text: 'Hayır',
                            class: 'green',
                            click: function () {

                            }
                        }]
                    });
            }
        },
        {
            tipi: "Ayraç"
        },
        {
            tipi: "Grup",
            baslik: "Dosya",
            alt: [
                {
                    baslik: "Dosyaya Kaydet (.FikoOp)",
                    simge: "save",
                    tiklandi: () => {
                        this.dosyayaKaydet();
                    }
                }
            ]
        },
        {
            tipi: "Ayraç"
        },
        {
            tipi: "Grup",
            baslik: "Konumlar",
            alt: [
                {
                    baslik: "Konum'a Git",
                    simge: "camera",
                    tiklandi: () => {
                        this.konum?.git();
                    },
                    gorunur: () => {
                        return this.konum
                    }
                },
                {
                    baslik: "Konum Kaydet",
                    simge: "save",
                    tiklandi: () => {
                        if (!this.konum)
                            this.konum = new FikoKonum(this.sahne);
                        this.konum?.kaydet();
                    },
                    gorunur: () => {
                        return !this.konum
                    }
                },
                {
                    baslik: "Konum Sil",
                    simge: "trash",
                    tiklandi: () => {
                        this.konum = null;
                    },
                    gorunur: () => {
                        return this.konum
                    }
                }
            ]
        }

    ]

    aracCubugu: any[] = [
        {
            baslik: "Düzenle",
            simge: "edit",
            tiklandi: () => {
                this.sahne.anaGosterim.DialogFiko.ac({ bilesen: FikoperasyonComponent, parametreler: { fikoperasyon: this }, $event: null, ayarlar: { baslik: 'Fikoperasyon Nitelikleri', simgeResim: './simgeler/proje.webp' } });
            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                let _this = this;
                $('body')
                    .toast({
                        message: `Fikoperasyon Ve Tüm Alt Aktiviteleri Silinecektir, Onaylıyormusunuz?`,
                        displayTime: 3000,
                        class: 'black',
                        classActions: 'top attached',
                        actions: [{
                            text: 'Evet Onaylıyorum',
                            class: 'red',
                            click: function () {
                                while (_this.children.length) {
                                    _this.remove(_this.children[0]);
                                }

                                _this.parent.remove(_this);
                                _this.sahne.anaGosterim.aktifItem = null;
                                _this.sahne.anaGosterim.FikoYT.degisti.emit();
                                _this.sahne.anaGosterim.ciz();
                            }
                        }, {
                            text: 'Hayır',
                            class: 'green',
                            click: function () {

                            }
                        }]
                    });
            }
        }
    ]

    get islemeEkseni(): FikoEksen {
        return this.children[0] as FikoEksen;
    };
    set islemeEkseni(val: FikoEksen) {
        // if (this.children.length > 0) {
        this.children[0] = val;
        // } else {
        //     this.ekle(val);
        // }
    };

    public override get liste(): Fikogram[] {
        return this.children as Fikogram[];
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/proje.webp";

        this.ekle(new FikoEksen(this.sahne));

        // this.islemeEkseni = this.children[0] as FikoEksen;
        this.islemeEkseni.name = this.name + ".İşleme Ekseni";

        this.islemeEkseni.userData['FikoArayuz'].agactaGorunur = true;
        this.islemeEkseni.userData['FikoArayuz'].listeGoster = false;
        this.islemeEkseni.userData['FikoArayuz'].simge = "./simgeler/xyz-1.webp";

        this.userData['eksenid'] = this.islemeEkseni.uuid;

        this.ekle(new FikoCizimler(this.sahne, this.name + " Çizimleri"));
        // this.cizimler = new FikoCizimler(this.sahne, this.name + " Çizimleri");
        // this.cizimler = new FikoCizimler(this.sahne, this.name + " Çizimleri");
        this.cizimler.userData['FikoArayuz'].agactaGorunur = true;
        this.cizimler.userData['FikoArayuz'].listeGoster = true;
        // this.ekle(this.cizimler);


        this.ekle(new Fikogramlar(this.sahne, "Nc Programlar"));
        this.programlar.userData['FikoArayuz'].agactaGorunur = true;
        this.programlar.userData['FikoArayuz'].listeGoster = true;

        this.sahne?.anaGosterim?.FikoYT.degisti.emit();
    }

    ekleFikogram(isim?: string) {
        this.programlar.ekle(new Fikogram(this.sahne, isim ? isim : 'Fikogram.' + this.sayac));
        this.sayac += 1;
    }

    tiklandi() {
        this.konum?.git();
    }
    ciftTiklandi() {
        this.sahne.anaGosterim.DialogFiko.ac({ bilesen: FikoperasyonComponent, parametreler: { fikoperasyon: this }, $event: null, ayarlar: { baslik: 'Fikoperasyon Nitelikleri', simgeResim: './simgeler/proje.webp' } });
    }

    ekleDosyadan(filter?: string) {
        var _this = this;
        let input = document.createElement("input");
        input.type = "file";
        input.multiple = true;
        var _tempDosyalar: any;
        input.onchange = async ($event: any) => {
            if (!_tempDosyalar) {
                _tempDosyalar = $event.target.files
            }
            if (_tempDosyalar && _tempDosyalar[0]) {
                for (let i = 0; i < _tempDosyalar.length; i++) {
                    const dosya = _tempDosyalar[i];
                    // const dosya: File = $event.target.files[0]
                    await _this.ekleApt(dosya);
                }
            }
        }
        input.click();
    }

    async ekleApt(dosya: any) {
        var _this = this;

        return new Promise((resolve: any, reject) => {

            this.loader.load(URL.createObjectURL(dosya),

                (data: any) => {
                    let fikoApt = new FikoApt(this.sahne);

                    fikoApt.arrayApt = data.split("\n");
                    fikoApt.parcala();
                    // fikoApt.agactaGorunur = true;
                    fikoApt.name = fikoApt.name.replace(".FikoAPT", "");

                    _this.add(fikoApt);

                    _this.sahne.anaGosterim.FikoYT.degisti.emit();
                    resolve();
                },
                // function (xhr) {
                //     console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                // },
                // function (err) {
                //     console.error(err);
                // }
            );

        });
    }


    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } // super.toJSON(meta);
        if (this.islemeEkseni) {
            _rslt.eksen = this.islemeEkseni.toJSON();
        }

        _rslt.cizimler = this.cizimler.toJSON();
        _rslt.programlar = this.programlar.toJSON();
        if (this.seciliKutukUuid) {
            _rslt.seciliKutukUuid = this.seciliKutukUuid;
        }
        if (this.konum) {
            _rslt.konum = this.konum.toJSON();
        }

        // userData kaydet (FikoParametreler, FikoArayuz, cizimler, eksenid, custom props)
        _rslt.userData = this._serializeUserData();

        // visible durumu
        _rslt.visible = this.visible;

        // matrix (position/rotation/scale)
        _rslt.matrix = this.matrix.toArray();

        // Kamera durumunu kaydet (dosya export anindaki gorunum)
        if (this.sahne?.anaGosterim?.aktifKamera && this.sahne?.anaGosterim?.aktifKontrol) {
            const kamera = this.sahne.anaGosterim.aktifKamera;
            const kontrol = this.sahne.anaGosterim.aktifKontrol;
            const canvas = this.sahne.anaGosterim.canvas?.nativeElement;
            _rslt.kameraDurumu = {
                position: kamera.position.toArray(),
                quaternion: kamera.quaternion.toArray(),
                up: kamera.up.toArray(),
                zoom: kamera.zoom,
                hedef: kontrol.target.toArray(),
                oran: canvas ? canvas.clientWidth / canvas.clientHeight : 1,
            };
        }

        return _rslt;
    }

    /** Import sirasinda kamera durumunu uygula (dosyadanYukle sonrasi cagirilmali) */
    kameraDurumuUygula(): void {
        if (!this._kameraDurumuJson || !this.sahne?.anaGosterim) return;

        const json = this._kameraDurumuJson;
        const kamera = this.sahne.anaGosterim.aktifKamera;
        const kontrol = this.sahne.anaGosterim.aktifKontrol;
        const canvas = this.sahne.anaGosterim.canvas?.nativeElement;

        if (kamera && json.position) {
            kamera.position.fromArray(json.position);
        }
        if (kamera && json.quaternion) {
            kamera.quaternion.fromArray(json.quaternion);
        }
        if (kamera && json.up) {
            kamera.up.fromArray(json.up);
        }
        if (kamera && json.zoom !== undefined) {
            // Oran farki varsa zoom ayarla
            const eskiOran = json.oran || 1;
            const yeniOran = canvas ? canvas.clientWidth / canvas.clientHeight : 1;
            kamera.zoom = (yeniOran * json.zoom) / eskiOran;
            kamera.updateProjectionMatrix();
        }
        if (kontrol && json.hedef) {
            kontrol.target.fromArray(json.hedef);
            kontrol.update();
        }

        // Bir kez uygulandi, tekrar uygulanmasin
        this._kameraDurumuJson = null;
        this.sahne.anaGosterim.ciz();
    }

    /** Kamera durumu JSON (import sonrasi uygulanmak uzere) */
    private _kameraDurumuJson: any = null;

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any, binBuffers?: Uint8Array[]) {
        const _rslt = new FikoOperasyon(sahne, json.isim);
        _rslt.uuid = json.uuid;
        _rslt.parent = parent;

        _rslt.islemeEkseni = FikoEksen.fromJson(sahne, _rslt, json.eksen);

        _rslt.cizimler = FikoCizimler.fromJson(sahne, _rslt, json.cizimler, binBuffers);

        _rslt.programlar = Fikogramlar.fromJson(sahne, _rslt, json.programlar);
        if (json.seciliKutukUuid) {
            _rslt.seciliKutukUuid = json.seciliKutukUuid;
        }
        if (json.konum) {
            _rslt.konum = new FikoKonum(sahne, json.konum.ismi, json.konum.aciklama, json.konum.veri);
        }

        // userData geri yukle
        if (json.userData) {
            _rslt._restoreUserData(json.userData);
        }

        // visible durumu
        if (json.visible !== undefined) {
            _rslt.visible = json.visible;
        }

        // matrix (position/rotation/scale)
        if (json.matrix) {
            _rslt.matrix.fromArray(json.matrix);
            _rslt.matrix.decompose(_rslt.position, _rslt.quaternion, _rslt.scale);
        }

        // Kamera durumunu sakla (sonra uygulanmak uzere)
        if (json.kameraDurumu) {
            _rslt._kameraDurumuJson = json.kameraDurumu;
        }

        return _rslt;
    }

    private static async gzipSikistir(veri: string): Promise<Blob> {
        const encoder = new TextEncoder();
        const stream = new Blob([encoder.encode(veri)]).stream();
        const compressed = stream.pipeThrough(new CompressionStream('gzip'));
        return new Response(compressed).blob();
    }

    private static async gzipCoz(veri: ArrayBuffer): Promise<string> {
        const stream = new Blob([veri]).stream();
        const decompressed = stream.pipeThrough(new DecompressionStream('gzip'));
        return new Response(decompressed).text();
    }

    private static gzipMi(buffer: ArrayBuffer): boolean {
        const bytes = new Uint8Array(buffer);
        return bytes.length >= 2 && bytes[0] === 0x1F && bytes[1] === 0x8B;
    }

    async dosyayaKaydet() {
        const jsonStr = JSON.stringify(this.toJSON());
        const gzipBlob = await FikoOperasyon.gzipSikistir(jsonStr);

        // @ts-ignore - File System Access API
        if (typeof window !== 'undefined' && window.showSaveFilePicker) {
            try {
                // @ts-ignore
                const handle = await window.showSaveFilePicker({
                    suggestedName: (this.name || 'FikoOperasyon') + '.FikoOp',
                    types: [{
                        description: 'FikoOperasyon Dosyasi',
                        accept: { 'application/octet-stream': ['.FikoOp'] },
                    }],
                });
                const writable = await handle.createWritable();
                await writable.write(gzipBlob);
                await writable.close();
                return;
            } catch (e) {
                if ((e as any)?.name === 'AbortError') return;
            }
        }

        const url = URL.createObjectURL(gzipBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = (this.name || 'FikoOperasyon') + '.FikoOp';
        a.click();
        URL.revokeObjectURL(url);
    }

    static async dosyadanYukle(sahne: FikoSahne, parent?: any): Promise<FikoOperasyon | null> {
        return new Promise((resolve) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.FikoOp';
            input.onchange = async ($event: any) => {
                const dosya = $event.target.files?.[0];
                if (!dosya) { resolve(null); return; }

                try {
                    const buffer = await dosya.arrayBuffer();
                    let jsonStr: string;

                    if (FikoOperasyon.gzipMi(buffer)) {
                        jsonStr = await FikoOperasyon.gzipCoz(buffer);
                    } else {
                        jsonStr = new TextDecoder().decode(buffer);
                    }

                    const json = JSON.parse(jsonStr);
                    const operasyon = FikoOperasyon.fromJson(sahne, parent, json);

                    // Kamera durumunu uygula (kaydedildigi gibi gorunsun)
                    // setTimeout ile render dongusu tamamlansin
                    setTimeout(() => {
                        operasyon.kameraDurumuUygula();
                    }, 100);

                    resolve(operasyon);
                } catch (e) {
                    console.error('FikoOp dosya okuma hatasi:', e);
                    resolve(null);
                }
            };
            input.click();
        });
    }

    toStr() {
        let _rslt = `{ "uuid":"${this.uuid}","ismi": "${this.name}","type":"${this.type}",`;
        _rslt += `"eksen": ${JSON.stringify(this.islemeEkseni.toJSON())},`
        _rslt += `"cizimler":${this.cizimler.toStr()}`;
        _rslt += `}`;

        return _rslt;
    }
}